import { render, staticRenderFns } from "./RankData.vue?vue&type=template&id=689b82b8&scoped=true&"
import script from "./RankData.vue?vue&type=script&lang=js&"
export * from "./RankData.vue?vue&type=script&lang=js&"
import style0 from "./RankData.vue?vue&type=style&index=0&id=689b82b8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689b82b8",
  null
  
)

export default component.exports